import { newSpecPage } from '@stencil/core/testing';
import { DashButtonComponent } from './dash-button';

describe('dash-button', () => {
  it('renders', async () => {
    const { root } = await newSpecPage({
      components: [DashButtonComponent],
      html: '<dash-button></dash-button>',
    });
    expect(root).toEqualHtml(`
      <dash-button>
        <mock:shadow-root>
          <div>
            Hello, World! I'm
          </div>
        </mock:shadow-root>
      </dash-button>
    `);
  });

  it('renders with values', async () => {
    const { root } = await newSpecPage({
      components: [DashButtonComponent],
      html: `<dash-button first="Stencil" last="'Don't call me a framework' JS"></dash-button>`,
    });
    expect(root).toEqualHtml(`
      <dash-button first="Stencil" last="'Don't call me a framework' JS">
        <mock:shadow-root>
          <div>
            Hello, World! I'm Stencil 'Don't call me a framework' JS
          </div>
        </mock:shadow-root>
      </dash-button>
    `);
  });
});
